class PpPdpReinsurance extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-reinsurance-track]');
    this.slides = Array.from(this.querySelectorAll('[data-reinsurance-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-reinsurance-dot]'));

    if (!this.track || this.slides.length <= 1) return;

    this.current = 0;
    this.autoplayMs = Number(this.dataset.autoplay) || 5000;
    this.timer = null;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goTo(index);
        this.resetAutoplay();
      });
    });

    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());
    this.addEventListener('focusin', () => this.stopAutoplay());
    this.addEventListener('focusout', () => this.startAutoplay());

    this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  goTo(index) {
    this.current = index;
    this.track.style.transform = `translateX(-${index * 100}%)`;

    this.dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === index);
      dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
    });
  }

  next() {
    const nextIndex = (this.current + 1) % this.slides.length;
    this.goTo(nextIndex);
  }

  startAutoplay() {
    if (this.slides.length <= 1) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.stopAutoplay();
    this.timer = window.setInterval(() => this.next(), this.autoplayMs);
  }

  stopAutoplay() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  resetAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}

if (!customElements.get('pp-pdp-reinsurance')) {
  customElements.define('pp-pdp-reinsurance', PpPdpReinsurance);
}
